import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from 'viewbid-shared-lib';
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { AuctionLotListPageComponent } from './pages/auction-lot-list-page/auction-lot-list-page.component';
import * as fromAuctionsPage from './state/auctions-page-state/auctions-page.reducer';
import { TopRatedProductsComponent } from './components/product/top-rated-products/top-rated-products.component';
import { PaginationComponent } from './components/ui/pagination/pagination.component';
import { NiceSelectComponent } from './components/ui/nice-select/nice-select.component';
import { MobileSidebarComponent } from './components/offcanvas/mobile-sidebar/mobile-sidebar.component';
import { CartSidebarComponent } from './components/offcanvas/cart-sidebar/cart-sidebar.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AuctionsPageComponent } from './pages/auctions-page/auctions-page.component';
import { AuctionsRoutingModule } from './auctions-routing.module';
import { StoreModule } from '@ngrx/store';
import * as fromSelectedAuction from './state/selected-auction-state/selected-auction.reducer';
import * as fromSelectedLot from './state/selected-lot-state/selected-lot.reducer';
import { EffectsModule } from '@ngrx/effects';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpTranslateLoader } from '../../../http-translate-loader';
import { VBProductDetailsComponent } from './pages/vb-product-details/vb-product-details.component';
import { MatIconModule } from '@angular/material/icon';
import { VbAdCardComponent } from './components/vb-ad-card/vb-ad-card.component';
import { AuctionSummaryComponent } from './components/auction-summary/auction-summary.component';
import { MaskPipe } from './pipe/mask.pipe';
import { SharedModule } from '../../shared/shared.module';
import {
    watchlistPageFeatureKey,
    watchlistReducer,
} from '../profiles/state/watchlist-page-state/watchlist-page-state.reducer';
import { BidHistoryTableComponent } from '../../shared/components/bid-history-table/bid-history-table.component';
import { LotItemUserNotesComponent } from './components/product/lot-item-user-notes/lot-item-user-notes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LotItemAlertsComponent } from './components/product/lot-item-alerts/lot-item-alerts.component';
import { LotEditHistoryComponent } from './components/product/lot-edit-history/lot-edit-history.component';
import { SchedulerDialogComponent } from '../../shared/components/scheduler-dialog/scheduler-dialog.component';
import { MakeOfferComponent } from './components/product/make-offer/make-offer.component';
import {
    VbAuctionFilterModalComponent,
    VbLotFilterModalComponent,
    VbSpinnerComponent,
} from '@viewbid/ui';

@NgModule({
    declarations: [
        AuctionLotListPageComponent,
        TopRatedProductsComponent,
        PaginationComponent,
        NiceSelectComponent,
        MobileSidebarComponent,
        CartSidebarComponent,
        AuctionsPageComponent,
        VBProductDetailsComponent,
        VbAdCardComponent,
        AuctionSummaryComponent,
        BidHistoryTableComponent,
        MaskPipe,
        LotItemUserNotesComponent,
        LotItemAlertsComponent,
        LotEditHistoryComponent,
        MakeOfferComponent,
    ],
    exports: [
        AuctionLotListPageComponent,
        TopRatedProductsComponent,
        PaginationComponent,
        NiceSelectComponent,
        MobileSidebarComponent,
        CartSidebarComponent,
        VBProductDetailsComponent,
        VbAdCardComponent,
        AuctionSummaryComponent,
        BidHistoryTableComponent,
        LotItemAlertsComponent,
        MaskPipe,
    ],
    imports: [
        SharedModule,
        CommonModule,
        AuctionsRoutingModule,
        StoreModule.forFeature(
            fromSelectedAuction.selectedAuctionFeatureKey,
            fromSelectedAuction.selectedAuctionStateReducer,
        ),
        StoreModule.forFeature(
            fromAuctionsPage.auctionsPageFeatureKey,
            fromAuctionsPage.auctionsPageReducer,
        ),
        StoreModule.forFeature(
            fromSelectedLot.selectedLotFeatureKey,
            fromSelectedLot.selectedLotStateReducer,
        ),
        StoreModule.forFeature(watchlistPageFeatureKey, watchlistReducer),
        EffectsModule.forFeature(),
        AuthModule,
        MatIconModule,
        NgxSliderModule,
        AuctionsRoutingModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        VbLotFilterModalComponent,
        VbAuctionFilterModalComponent,
        VbSpinnerComponent,
    ],
    providers: [
        SchedulerDialogComponent,
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AuctionsModule {}
